import script from "./UIInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./UIInput.vue?vue&type=script&setup=true&lang=ts"

import "./UIInput.vue?vue&type=style&index=0&id=d85974fe&lang=css"

const __exports__ = script;

export default __exports__